import { createGlobalStyle } from 'styled-components';

// Import Google Fonts for Arabic text
import '@fontsource/cairo'; // Arabic font

const GlobalStyles = createGlobalStyle`
  html, body {
    width: 100%;
    overflow-x: hidden;
  }
  
  html[dir='rtl'] body {
    font-family: 'Cairo', sans-serif;
  }
  
  html[dir='rtl'] * {
    font-family: 'Cairo', sans-serif;
  }
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  body {
    line-height: 1.6;
    color: #333;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
  }
`;

export default GlobalStyles;
